import React from 'react';
import TimelineDay from './TimelineDay';
import { HistoryItem } from './types';
import { Flex } from 'rebass';

type TimelineYearProps = {
  noRail?: boolean;
  itemsByDay: {
    [date: string]: HistoryItem[];
  };
};

const TimelineYear: React.FC<TimelineYearProps> = ({
  noRail = false,
  itemsByDay,
}) => {
  return (
    <Flex flexDirection="column" sx={{ gap: 6 }}>
      {Object.keys(itemsByDay).map((dayFormatted, dayIndex) => {
        const historyItems = itemsByDay[dayFormatted];
        const isFirstDate = dayIndex === 0;
        const isLastDate = dayIndex + 1 === Object.keys(itemsByDay).length;

        return (
          <TimelineDay
            key={dayIndex}
            dayIndex={dayIndex}
            dayFormatted={dayFormatted}
            isFirstDate={isFirstDate}
            isLastDate={isLastDate}
            historyItems={historyItems}
            noRail={noRail}
          />
        );
      })}
    </Flex>
  );
};

export default TimelineYear;
